import { ApiClient } from './ApiClient';

export const getCountries = () => ApiClient.get('/models/admin/countries');
export const getClients = () => ApiClient.get('/clients');
export const addClient = (payload) => ApiClient.post('/clients', payload);
export const updateClient = (payload) => ApiClient.put('/clients', payload);
export const deleteClient = (payload) => ApiClient.delete('/clients', { data: payload });
